module.exports = __webpack_public_path__ + "static/contribution_img2_on@2x-cfa29a4d0d6ac58884410075f650358e.jpg";